export default function upperFirst(string) {
  return `${string.charAt(0).toUpperCase()}${string.substring(1)}`;
}
